<template>
  <span class="au-tooltip">
    <span
      v-if="type === 'question'"
      ref="tooltip"
      class="tooltip-content"
    >
      <span class="tooltip-text">?</span>
    </span>
    <span
      v-if="type === 'info'"
      ref="tooltip"
    >
      <div class="tooltip-round" />
    </span>
    <span
      v-if="type === 'slot'"
      ref="tooltip"
    >
      <slot />
    </span>
  </span>
</template>

<script setup>
import tippy from "tippy.js";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import "tippy.js/dist/tippy.css";

const props = defineProps({
  text: {
    type: String,
    default: ""
  },
  type: {
    type: String,
    default: "question"
  }
});

const store = useStore();
const tooltip = ref(null);
const tippyInstance = ref(null);

const theme = computed(() => (store.getters.isLightTheme ? "light" : "dark"));

watch(theme, (newTheme) => {
  if (tippyInstance.value) {
    tippyInstance.value.setProps({ theme: newTheme });
  }
});

const initTippy = () => {
  tippyInstance.value = tippy(tooltip.value, {
    allowHTML: true,
    arrow: true,
    content: props.text,
    theme: theme.value,
    trigger: "mouseenter click"
  });
};

onMounted(() => {
  initTippy();
});

onBeforeUnmount(() => {
  if (tippyInstance.value) {
    tippyInstance.value.destroy();
  }
});
</script>
<style lang="scss">
.au-tooltip {
  position: relative;
  cursor: pointer;
}
.tooltip-content {
  position: absolute;
}

.tooltip-round {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #5fc396;
  border-radius: 50%;
  cursor: pointer;
}

.tooltip-text {
  font-size: 14px;
  display: flex;
  cursor: pointer;
  color: #888;
  margin-top: -5px;
  margin-left: 3px;
}

.tippy-box[data-theme~="light"] {
  padding: 2px;
  background-color: #1c2434;
  color: #fff;
  border-radius: 6px;
  font-size: 14px;
}

.tippy-box[data-theme~="light"][data-placement^="top"] > .tippy-arrow:before {
  border-top-color: #1c2434;
}
.tippy-box[data-theme~="light"][data-placement^="bottom"]
  > .tippy-arrow:before {
  border-bottom-color: #1c2434;
}

.tippy-box[data-theme~="dark"] {
  padding: 2px;
  background-color: #fff;
  color: #1c2434;
  border-radius: 6px;
  font-size: 14px;
}

.tippy-box[data-theme~="dark"][data-placement^="top"] > .tippy-arrow:before {
  border-top-color: #fff;
}
.tippy-box[data-theme~="dark"][data-placement^="bottom"] > .tippy-arrow:before {
  border-bottom-color: #fff;
}

.tippy-box .tippy-content > div {
  font-size: 14px;
}

.tippy-box .tippy-content > li {
  text-indent: 8px;
}
.tippy-box .tippy-content > li {
  list-style: none;
  position: relative;
  padding-left: 18px;
}

.tippy-box .tippy-content > li::before {
  content: "•";
  position: absolute;
  left: 0;
  font-size: 14px;
}
</style>
